<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      title: "Adoptuj pszczołę i chroń z nami zapylacze! 🐝🦋🐝",
    };
  },
  updated() {
    let type = 'Pozostałe';

    //, Formularz zamówienia (strona formularza adopcji), Potwierdzenie zamówienia (strona z potwierdzeniem złożenia zamówienia), Błąd 404
    if (this.$route.fullPath == ("/")) {
      type = 'Strona główna';
    }
    if (this.$route.fullPath == ("/kontakt")) {
      type = 'Kontakt';
    }
    if (this.$route.fullPath.includes("pytania-i-odpowiedzi")) {
      type = 'Pytania i odpowiedzi';
    }

    window.trackUrl(this.$route.fullPath, document.title + " | " + this.$route.fullPath, type)
  }
};

window.trackAdoptionForm = function() {
  console.log("trackAdoption");
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event': 'virtualPageview',
    'virtualPageURL': '/formularz-adopcji',
    'virtualPageTitle': 'Formularz zamówienia',
    'pageType' : 'Formularz zamówienia',
    'viewForm' : '1'
  });
}

window.trackUrl = function(url, title, type) {
  console.log("trackUrl");
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event': 'virtualPageview',
    'virtualPageURL': url,
    'virtualPageTitle': title,
    'pageType' : type,
  });
}
window.trackClickButton = function(buttonName) {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event' : 'clickButton',
    'buttonName' : buttonName,
    'buttonAdopt' : '1'
  });
}

window.trackFormClick = function(event,formName,fieldName,clickField) {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event' : event,
    'formName' : formName,
    'fieldName' : fieldName,
    'clickField' : clickField
  });
}

window.goToPayment = function() {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event' : 'formSubmitted',
    'formName' : 'Formularz Adoptuję',
    'sendForm':'1'
  });
}

window.clickAdoptujButton = function() {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event' : 'clickButton',
    'buttonName' : 'Przycisk Adoptuję',
    'buttonAdopt' : '1'
  });
}

window.formFieldClick = function(fieldName) {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event' : 'formClickField',
    'formName' : 'Formularz Adoptuję',
    'fieldName' : fieldName,
    'clickField' : '1'
  });
}

window.errorOnFormField = function(fieldName, errorMessage) {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event' : 'formFieldError',
    'formName' : 'Formularz Adoptuję',
    'fieldName' : fieldName,
    'errorMessage' : errorMessage,
    'errorField' : '1'
  });
}


</script>

<style lang="scss">
@import "src/assets/scss/main.scss";
</style>

